import React, { Fragment } from 'react';

import { Alert, Grid, Typography } from '@mui/material';
import { Box } from '@mui/system';

import useCreateEditLead from '../../../../hooks/Admin/Leads/useCreateEditLead';
import { formGenerator } from '../../../../helpers/formGenerator';
import { BroadcastGroupActionType } from '../../../../helpers/Constants';
import CustomBreadcrumbs from '../../../common/CustomBreadcrumbs';
import CustomButton from '../../../common/CustomButton';
import strings from '../../../../localization';

import {
  leadFieldConfig,
  createCrumbs,
  editCrumbs,
} from './helper';
import BroadcastGroupEmails from './BroadcastGroupEmails';
import styles from './styles';

interface ICreateEditLead {
  type: BroadcastGroupActionType;
}

const CreateEditLead = ({ type }: ICreateEditLead) => {
  const {
    broadcastGroupOptions,
    campaignOptions,
    campaignUserType,
    cannotMapBroadcastGroup,
    formik,
    handleRemoveEmail,
    isBroadcastGroupCreation,
    isEdit,
  } = useCreateEditLead(type);

  return (
    <Box sx={styles.container}>
      <Box sx={styles.crumbContainer}>
        <CustomBreadcrumbs crumbs={isEdit ? editCrumbs : createCrumbs} />
      </Box>
      <Typography sx={styles.title}>
        {isEdit ? strings.editLead : strings.createLead}
      </Typography>

      <Grid container xs={12}>
        {leadFieldConfig(
          campaignOptions,
          campaignUserType,
          {
            broadcastGroupOptions,
            creationMethod: formik.values.creationMethod,
            isEdit,
          },
        ).map((item) => {
          const { key } = item;
          return <Fragment key={key}>{formGenerator(item, formik)}</Fragment>;
        })}
        {isBroadcastGroupCreation && (
          <Grid item xs={6}>
            <BroadcastGroupEmails
              emails={formik.values.emails}
              error={
                formik.touched.emails
                  ? formik.errors.emails as string
                  : undefined
              }
              onRemove={handleRemoveEmail}
            />
          </Grid>
        )}
        {cannotMapBroadcastGroup && (
          <Grid item xs={12}>
            <Alert severity="error" sx={styles.mappingError}>
              {strings.selectedBroadcastGroupCannotBeMapped}
            </Alert>
          </Grid>
        )}
      </Grid>

      <Grid container xs={12} sx={styles.buttonContainer}>
        <CustomButton
          label={isEdit ? strings.save : strings.create}
          onClick={formik.handleSubmit}
          disabled={cannotMapBroadcastGroup}
        />
      </Grid>
    </Box>
  );
};

export default CreateEditLead;
